<script setup lang="ts" name="SailingScheduleNoDataCard">
import BaseCardNoData from '~/components/BaseCardNoData.vue';
</script>

<template>
  <BaseCardNoData illustration="no-data" styled>
    <template #message>
      <p class="mt-2 text-body-1 text-charcoal-6">
        Sailing schedule is not available at the moment. Contact your admin or
        <a
          href="mailto:myg2support@g2ocean.com"
          class="text-primary-8"
          target="_blank"
          >support team</a
        >
        for further invite.
      </p>
    </template>
  </BaseCardNoData>
</template>
